import { PlayerPortalsGridPageProps } from './types';
import { FC } from 'react';
import classnames from 'classnames';
import { RenderOn } from '../../RenderOn/RenderOn';
import { IContentItem } from '@kontent-ai/delivery-sdk';
import {
  AsyncComponent,
  ConfiguredComponents,
} from '@r-and-a-shared-ui/core-component-config';
import styles from './PlayerPortalsGridPage.module.scss';

export const PlayerPortalsGridPageBodyContent: FC<
  Pick<PlayerPortalsGridPageProps, 'pageColumns'>
> = ({ pageColumns }) => {
  return (
    <>
      <main data-testid={'gridPage'} className={classnames(styles.wrapper)}>
        <div data-testid={'body-content'} className={styles.content}>
          <RenderOn condition={!!pageColumns?.length}>
            {pageColumns?.map((x: IContentItem<any>) => {
              return (
                <AsyncComponent
                  kontentItem={x}
                  contentType={x.system.type as ConfiguredComponents}
                  key={x.system.id}
                />
              );
            })}
          </RenderOn>
        </div>
      </main>
    </>
  );
};
